import { LangType, Translations } from '../typings/lang';
import en from './en.json';
import fr from './fr.json';

const translations: Translations = { en, fr };

export const translation = (lang: LangType, key: string): string => {
  return translations[lang][key] || translations['en'][key];
};
